<!--
  Gives back template slots normally give by <comparator>
  Similar usage than <comparator> but more simple

  Properties:
  - listeners: a dict of listeners, that will be forwarded to the template
      only when displaying the view (and not the compare)
  - attrs: a dict of attributes, that will be forwarded to the template
      only when displaying the view (and not the compare)
      to be used in v-bind
      to be used in v-on
  - vuedata: an arbitrary object forwarded to the template
      if it is a function, it will be evaluated before passing to each item
  - :prop="...": merged with attrs
  - @event="...": merge with listeners

  The template recieves:
  - value: the main value (can be view, compare, or an item of them)
  - other: the value compared with (can be compare or an item of it)
  - index: the index of the item (if view is an array)
  - view: if displaying the view
  - compare: if displaying the compare (=!view)
  - listeners: the listeners attribute,
      only when displaying the view (and not the compare)
      to be used in v-on
  - attrs: the attributes attribute,
      only when displaying the view (and not the compare)
      to be used in v-bind
  - vuedata: the vuedata attribute, or the one of the <comparator>
-->

<script>
export default {
  name: 'ComparatorFilter',
  props: {
    listeners: Object,
    attrs: Object,
    vuedata: [Object, Function, Boolean],
  },
  inject: {
    // look for the ComparatorVue
    comparator: { default: null },
  },
  data () {
    return {
      // a copy of vuedata attribute
      vuedataCopy: null,
    }
  },
  computed: {
    /* merges the listeners */
    computedListeners () {
      return {
        ...this.$listeners,
        ...(this.listeners || {}),
      }
    },
    /* merges the attrs */
    computedAttrs () {
      return {
        ...this.$attrs,
        ...(this.attrs || {}),
      }
    },
    /* value from the comparator */
    value () {
      if (!this.comparator) return undefined
      return this.comparator.value
    },
    /* other from the comparator */
    other () {
      if (!this.comparator) return undefined
      return this.comparator.other
    },
    /* other from the comparator */
    compare () {
      if (!this.comparator) return false
      return this.comparator.compare
    },
    /* index from the comparator */
    index () {
      if (!this.comparator) return undefined
      return this.comparator.index
    },
    /* vuedata if defined, else comparator vuedata */
    computedVuedata () {
      if (this.vuedataCopy) return this.vuedataCopy
      else if (this.comparator) return this.comparator.vuedata
      else return {}
    },
  },
  /* init vuedataCopy */
  created () {
    if (!this.vuedata) {
      this.vuedataCopy = null
    } else if (typeof this.vuedata === 'function') {
      this.vuedataCopy = this.vuedata()
    } else if (typeof this.vuedata === 'object') {
      this.vuedataCopy = { ...this.vuedata }
    } else this.vuedataCopy = {}
  },
  /* Just render the template with parameters */
  render () {
    return this.$scopedSlots.default({
      value: this.value,
      other: this.other,
      view: !this.compare || undefined,
      compare: this.compare || undefined,
      index: this.index,
      listeners: this.compare ? {} : this.computedListeners,
      attrs: this.compare ? {} : this.computedAttrs,
      vuedata: this.computedVuedata,
    })
  },
}
</script>
